import type { User } from '@/types';
import type { SubscriptionTier } from '@/components/tour/tourSteps';

/**
 * Single source of truth for which tier copy the guided tour shows.
 *
 * Two entry points compute the tier: `WelcomeModal` (when the modal-driven
 * tour is started) and `Tool.tsx` (when the onboarding handoff skips the modal
 * and starts the tour directly). They previously diverged on whether
 * `is_admin` counted as pro — the same admin user could see pro-tier copy
 * from one path and basic-tier copy from the other. Centralizing fixes that.
 */
export function getTourTier(user: User | null | undefined): SubscriptionTier {
  if (!user) return 'basic';
  if (user.is_pro || user.is_trial || user.is_admin) return 'pro';
  if (user.is_basic_plus) return 'basic_plus';
  return 'basic';
}
